import { AUTH_API } from "../config/config";

export const checkEmailExists = async (email) => {
  const request = { email };
  const response = await fetch(AUTH_API + "/user/signup/check", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  });
  return response.json();
};

export const saveAuthRelay = async (authState) => {
  const response = await fetch(AUTH_API + "/auth/user/relay/save", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(authState),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload?.error) {
    const error = new Error("Unable to deliver the user session.");
    error.name = "UserRelayDeliveryError";
    error.status = response.status;
    // Do not surface untrusted server messages, which may include token details.
    error.code = ["BAD_REQUEST", "UNAUTHENTICATED", "UNAUTHORIZED"].includes(
      payload?.error
    )
      ? payload.error
      : "DELIVERY_FAILED";
    throw error;
  }
  return payload?.data && typeof payload.data === "object"
    ? payload.data
    : payload;
};

export const checkPairingAuthRelay = async (relayId, pairingCode) => {
  const request = { flow: "pairing", relayId, pairingCode };
  const response = await fetch(AUTH_API + "/auth/user/relay/check", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  });
  return response.json();
};

export const checkCallbackAuthRelay = async (relayId, loginTicket) => {
  const response = await fetch(AUTH_API + "/auth/user/relay/check", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      flow: "callback",
      relayId,
      loginTicket,
    }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload?.error) {
    throw new Error("This login request is invalid or expired.");
  }
  const result =
    payload?.data && typeof payload.data === "object" ? payload.data : payload;
  if (result.success !== true) {
    throw new Error("This login request is invalid or expired.");
  }
  return result;
};
